import { api } from "../AxiosInstance";

export function getOrgsOfAdminApi(params) {
  return api().get("/api/OrganizationAdmin/GetOrganizationsOfOrgAdmin", { params });
}

export function setAdminApi(data) {
  return api().put("/api/Organization/SetOrganizationAdmin", data);
}